import { z } from "zod";

/**
 * Date formats of persisted JSON and API contracts. See @repo/utils/date for the rules.
 * Write instants with `toISOString()` (UTC, `Z`); older rows may carry an offset, so reads accept one.
 */
export const isoDateTimeSchema = z.iso.datetime({ offset: true });

/** Calendar date, `YYYY-MM-DD`. */
export const calendarDateSchema = z.iso.date({ error: "Date invalide" });
